// extracted by mini-css-extract-plugin
export default {"containerCourses":"App_containerCourses__G8Dqf","course":"App_course__re52X"};